import { render, staticRenderFns } from "./employee-emp-custody.vue?vue&type=template&id=61ba2355&scoped=true"
import script from "./employee-emp-custody.vue?vue&type=script&lang=js"
export * from "./employee-emp-custody.vue?vue&type=script&lang=js"
import style0 from "./employee-emp-custody.vue?vue&type=style&index=0&id=61ba2355&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ba2355",
  null
  
)

export default component.exports